import {ValidationFailure, ValidationFailures} from '@/api';
import {FormGroup, FormGroupProps, Intent} from '@blueprintjs/core';
import {ReactElement} from 'react';

export interface Props extends FormGroupProps {
	labelFor: string,
	failures: ValidationFailures | null,
	exactMatch?: boolean,
}

export default function ValidatedFormGroup({failures, exactMatch = true, ...props}: Props): ReactElement {
	if (failures) {
		const failure = extract(failures, props.labelFor, exactMatch);

		if (failure) {
			props.helperText = failure.message;
			props.intent = Intent.DANGER;
		}
	}

	return <FormGroup {...props} />;
}

export function extract(failures: ValidationFailures, key: string, exact = false): ValidationFailure | null {
	if (key in failures)
		return failures[key];
	else if (!exact) {
		for (const itemKey in failures) {
			if (!failures.hasOwnProperty(itemKey))
				continue;

			if (itemKey.startsWith(key))
				return failures[itemKey];
		}
	}

	return null;
}
